import { render, staticRenderFns } from "./StoryPrice.vue?vue&type=template&id=ed1f1a74&"
import script from "./StoryPrice.vue?vue&type=script&lang=js&"
export * from "./StoryPrice.vue?vue&type=script&lang=js&"
import style0 from "./StoryPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports